import moment from "moment"

export const getFormattedDate = (date: Maybe<string>) => {
  return moment(date, "YYYY-MM-DD").format("DD MMM YYYY")
}
